export default __webpack_public_path__ + "1c251db6a656efe3622b80099b95a18c.png";